/* Aleefy 3D world — floating 3D pet toys behind the whole page + 3D section entrances. No libraries. */
(function () {
  'use strict';
  var d = document, w = window;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = w.matchMedia && w.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------------- math ---------------- */
  function sub(a, b) { return [a[0] - b[0], a[1] - b[1], a[2] - b[2]]; }
  function dot(a, b) { return a[0] * b[0] + a[1] * b[1] + a[2] * b[2]; }
  function cross(a, b) { return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]]; }
  function norm(a) { var l = Math.hypot(a[0], a[1], a[2]) || 1; return [a[0] / l, a[1] / l, a[2] / l]; }
  function mul(a, b) {
    var o = new Float32Array(16);
    for (var c = 0; c < 4; c++) for (var r = 0; r < 4; r++)
      o[c * 4 + r] = a[r] * b[c * 4] + a[4 + r] * b[c * 4 + 1] + a[8 + r] * b[c * 4 + 2] + a[12 + r] * b[c * 4 + 3];
    return o;
  }
  function persp(fovy, asp, n, f) {
    var t = 1 / Math.tan(fovy / 2), o = new Float32Array(16);
    o[0] = t / asp; o[5] = t; o[10] = (f + n) / (n - f); o[11] = -1; o[14] = 2 * f * n / (n - f);
    return o;
  }
  function lookAt(e, c, u) {
    var z = norm(sub(e, c)), x = norm(cross(u, z)), y = cross(z, x);
    return new Float32Array([x[0], y[0], z[0], 0, x[1], y[1], z[1], 0, x[2], y[2], z[2], 0, -dot(x, e), -dot(y, e), -dot(z, e), 1]);
  }
  function local(n) {
    var t = n.t, r = n.r, s = n.s;
    var cy = Math.cos(r[1]), sy = Math.sin(r[1]), cz = Math.cos(r[2]), sz = Math.sin(r[2]), cx = Math.cos(r[0]), sx = Math.sin(r[0]);
    var Ry = [cy, 0, -sy, 0, 0, 1, 0, 0, sy, 0, cy, 0, 0, 0, 0, 1];
    var Rz = [cz, sz, 0, 0, -sz, cz, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
    var Rx = [1, 0, 0, 0, 0, cx, sx, 0, 0, -sx, cx, 0, 0, 0, 0, 1];
    var R = mul(mul(Ry, Rz), Rx);
    // M = T * R * S
    var o = new Float32Array(16);
    for (var i = 0; i < 3; i++) { o[i] = R[i] * s[0]; o[4 + i] = R[4 + i] * s[1]; o[8 + i] = R[8 + i] * s[2]; }
    o[12] = t[0]; o[13] = t[1]; o[14] = t[2]; o[15] = 1;
    return o;
  }
  function normalMat(m) {
    var a00 = m[0], a01 = m[1], a02 = m[2], a10 = m[4], a11 = m[5], a12 = m[6], a20 = m[8], a21 = m[9], a22 = m[10];
    var b01 = a22 * a11 - a12 * a21, b11 = -a22 * a10 + a12 * a20, b21 = a21 * a10 - a11 * a20;
    var det = a00 * b01 + a01 * b11 + a02 * b21;
    if (!det) return new Float32Array([1, 0, 0, 0, 1, 0, 0, 0, 1]);
    det = 1 / det;
    var inv = [b01 * det, (-a22 * a01 + a02 * a21) * det, (a12 * a01 - a02 * a11) * det,
      b11 * det, (a22 * a00 - a02 * a20) * det, (-a12 * a00 + a02 * a10) * det,
      b21 * det, (-a21 * a00 + a01 * a20) * det, (a11 * a00 - a01 * a10) * det];
    return new Float32Array([inv[0], inv[3], inv[6], inv[1], inv[4], inv[7], inv[2], inv[5], inv[8]]);
  }
  function xform(m, p) {
    return [m[0] * p[0] + m[4] * p[1] + m[8] * p[2] + m[12], m[1] * p[0] + m[5] * p[1] + m[9] * p[2] + m[13], m[2] * p[0] + m[6] * p[1] + m[10] * p[2] + m[14], m[3] * p[0] + m[7] * p[1] + m[11] * p[2] + m[15]];
  }
  function hex(h) { return [(h >> 16 & 255) / 255, (h >> 8 & 255) / 255, (h & 255) / 255]; }
  function lerp(a, b, k) { return a + (b - a) * k; }

  /* ---------------- geometry ---------------- */
  function G(pos, nrm, idx) { return { p: pos, n: nrm, i: idx }; }
  function sphereGeo(lat, lon) {
    var p = [], n = [], i = [];
    for (var a = 0; a <= lat; a++) {
      var th = a * Math.PI / lat;
      for (var b = 0; b <= lon; b++) {
        var ph = b * 2 * Math.PI / lon, x = Math.sin(th) * Math.cos(ph), y = Math.cos(th), z = Math.sin(th) * Math.sin(ph);
        p.push(x, y, z); n.push(x, y, z);
      }
    }
    for (a = 0; a < lat; a++) for (b = 0; b < lon; b++) {
      var q = a * (lon + 1) + b, r = q + lon + 1;
      i.push(q, r, q + 1, r, r + 1, q + 1);
    }
    return G(p, n, i);
  }
  function cylGeo(rt, rb, h, seg) {
    var p = [], n = [], i = [], sl = (rb - rt) / h, k, base;
    for (k = 0; k <= seg; k++) {
      var a = k / seg * Math.PI * 2, c = Math.cos(a), s = Math.sin(a), nn = norm([c, sl, s]);
      p.push(rt * c, h / 2, rt * s); n.push(nn[0], nn[1], nn[2]);
      p.push(rb * c, -h / 2, rb * s); n.push(nn[0], nn[1], nn[2]);
    }
    for (k = 0; k < seg; k++) { var v = k * 2; i.push(v, v + 2, v + 1, v + 1, v + 2, v + 3); }
    [[h / 2, 1, rt], [-h / 2, -1, rb]].forEach(function (cap) {
      if (cap[2] <= 0) return;
      base = p.length / 3; p.push(0, cap[0], 0); n.push(0, cap[1], 0);
      for (k = 0; k <= seg; k++) { var a2 = k / seg * Math.PI * 2; p.push(cap[2] * Math.cos(a2), cap[0], cap[2] * Math.sin(a2)); n.push(0, cap[1], 0); }
      for (k = 0; k < seg; k++) i.push(base, base + 1 + k, base + 2 + k);
    });
    return G(p, n, i);
  }
  function boxGeo() {
    var p = [], n = [], i = [];
    var F = [[1, 0, 0], [-1, 0, 0], [0, 1, 0], [0, -1, 0], [0, 0, 1], [0, 0, -1]];
    F.forEach(function (f) {
      var u = Math.abs(f[1]) === 1 ? [1, 0, 0] : [0, 1, 0], v = cross(f, u), b = p.length / 3;
      [[-1, -1], [1, -1], [1, 1], [-1, 1]].forEach(function (c) {
        p.push((f[0] + u[0] * c[0] + v[0] * c[1]) / 2, (f[1] + u[1] * c[0] + v[1] * c[1]) / 2, (f[2] + u[2] * c[0] + v[2] * c[1]) / 2);
        n.push(f[0], f[1], f[2]);
      });
      i.push(b, b + 1, b + 2, b, b + 2, b + 3);
    });
    return G(p, n, i);
  }
  function torusGeo(R, r, seg, tube) {
    var p = [], n = [], i = [];
    for (var a = 0; a <= seg; a++) {
      var u = a / seg * Math.PI * 2, cu = Math.cos(u), su = Math.sin(u);
      for (var b = 0; b <= tube; b++) {
        var v = b / tube * Math.PI * 2, cv = Math.cos(v), sv = Math.sin(v);
        p.push((R + r * cv) * cu, r * sv, (R + r * cv) * su); n.push(cv * cu, sv, cv * su);
      }
    }
    for (a = 0; a < seg; a++) for (b = 0; b < tube; b++) {
      var q = a * (tube + 1) + b, s2 = q + tube + 1;
      i.push(q, s2, q + 1, s2, s2 + 1, q + 1);
    }
    return G(p, n, i);
  }

  /* ---------------- scene graph ---------------- */
  function N(mesh, color, t, s, r) {
    return { mesh: mesh || null, color: color ? hex(color) : null, t: t || [0, 0, 0], s: s || [1, 1, 1], r: r || [0, 0, 0], kids: [], a: 1, vis: true };
  }
  function add(p, c) { p.kids.push(c); return c; }


  /* ---------- 3D section entrances + hero tilt (CSS-driven) ---------- */
  (function () {
    var secs = Array.prototype.slice.call(d.querySelectorAll('main > .shopify-section'));
    if (!secs.length) return;
    d.documentElement.classList.add('w3d');
    if (reduce || !('IntersectionObserver' in w)) return;
    secs.forEach(function (s, i) {
      if (i === 0) return;
      var r = s.getBoundingClientRect();
      if (r.top < w.innerHeight * 0.9) return;
      s.classList.add('w3d-sec');
      var io = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) { s.classList.add('w3d-in'); io.disconnect(); setTimeout(function () { s.classList.remove('w3d-sec', 'w3d-in'); }, 1400); }
      }, { threshold: 0.08 });
      io.observe(s);
    });
    var hero = d.querySelector('.p3h, .txh');
    if (hero && fine) {
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        hero.style.transform = 'perspective(1600px) rotateX(' + (-y * 3).toFixed(2) + 'deg) rotateY(' + (x * 4).toFixed(2) + 'deg)';
      });
      hero.addEventListener('pointerleave', function () { hero.style.transform = ''; });
    }
  })();

  /* ---------- floating 3D objects behind the page ---------- */
  var canvas = d.createElement('canvas');
  canvas.className = 'w3d-canvas';
  canvas.setAttribute('aria-hidden', 'true');
  var gl = canvas.getContext('webgl', { antialias: true, alpha: true, premultipliedAlpha: false });
  if (!gl) return;
  d.body.appendChild(canvas);
  var host = { removeChild: function () { canvas.remove(); } };
    /* shaders */
    var vs = 'attribute vec3 aP;attribute vec3 aN;uniform mat4 uM;uniform mat4 uVP;uniform mat3 uNM;varying vec3 vN;varying vec3 vW;' +
      'void main(){vec4 w=uM*vec4(aP,1.0);vW=w.xyz;vN=normalize(uNM*aN);gl_Position=uVP*w;}';
    var fs = 'precision mediump float;uniform vec3 uC;uniform vec3 uL;uniform vec3 uE;uniform float uA;uniform float uFlat;varying vec3 vN;varying vec3 vW;' +
      'void main(){vec3 n=normalize(vN);vec3 v=normalize(uE-vW);' +
      'if(uFlat>0.5){gl_FragColor=vec4(uC,uA);return;}' +
      'float dl=dot(n,uL);float toon=smoothstep(-0.05,0.25,dl)*0.55+0.45*smoothstep(-0.6,0.0,dl);' +
      'vec3 hemi=mix(vec3(0.62,0.78,0.7),vec3(1.0,0.97,0.9),n.y*0.5+0.5);' +
      'float rim=pow(1.0-max(dot(n,v),0.0),3.0);' +
      'float spec=pow(max(dot(reflect(-uL,n),v),0.0),28.0);' +
      'vec3 col=uC*(hemi*0.52+toon*0.62)+rim*0.22*vec3(1.0,0.95,0.85)+spec*0.18;' +
      'gl_FragColor=vec4(col,uA);}';
    function sh(type, src) { var s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s); return s; }
    var prog = gl.createProgram();
    gl.attachShader(prog, sh(gl.VERTEX_SHADER, vs)); gl.attachShader(prog, sh(gl.FRAGMENT_SHADER, fs));
    gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) { canvas.remove(); return; }
    gl.useProgram(prog);
    var loc = {
      aP: gl.getAttribLocation(prog, 'aP'), aN: gl.getAttribLocation(prog, 'aN'),
      uM: gl.getUniformLocation(prog, 'uM'), uVP: gl.getUniformLocation(prog, 'uVP'), uNM: gl.getUniformLocation(prog, 'uNM'),
      uC: gl.getUniformLocation(prog, 'uC'), uL: gl.getUniformLocation(prog, 'uL'), uE: gl.getUniformLocation(prog, 'uE'),
      uA: gl.getUniformLocation(prog, 'uA'), uFlat: gl.getUniformLocation(prog, 'uFlat')
    };
    function upload(g) {
      var inter = new Float32Array(g.p.length * 2);
      for (var k = 0; k < g.p.length / 3; k++) {
        inter.set([g.p[k * 3], g.p[k * 3 + 1], g.p[k * 3 + 2], g.n[k * 3], g.n[k * 3 + 1], g.n[k * 3 + 2]], k * 6);
      }
      var vb = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, vb); gl.bufferData(gl.ARRAY_BUFFER, inter, gl.STATIC_DRAW);
      var ib = gl.createBuffer(); gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, ib); gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(g.i), gl.STATIC_DRAW);
      return { vb: vb, ib: ib, count: g.i.length };
    }

    var SPH = upload(sphereGeo(16, 24)), SPHL = upload(sphereGeo(10, 14)), CONE = upload(cylGeo(0, 1, 1, 20)),
      TORT = upload(torusGeo(1, 0.07, 32, 8)), HEARTC = upload(cylGeo(0.2, 0, 0.26, 20));

    function bone(c) { var g = N(null); add(g, N(SPH, c, [0, 0, 0], [0.42, 0.1, 0.1])); [[0.42, 0.09], [0.42, -0.09], [-0.42, 0.09], [-0.42, -0.09]].forEach(function (q) { add(g, N(SPH, c, [q[0], q[1], 0], [0.14, 0.14, 0.14])); }); return g; }
    function ball(c) { var g = N(null); add(g, N(SPH, c, [0, 0, 0], [0.3, 0.3, 0.3])); add(g, N(TORT, 0xffffff, [0, 0, 0], [0.31, 0.31, 0.31], [0.5, 0, 0.9])); return g; }
    function yarn(c) { var g = N(null); add(g, N(SPH, c, [0, 0, 0], [0.28, 0.28, 0.28])); add(g, N(TORT, 0xffffff, [0, 0, 0], [0.29, 0.29, 0.29], [0.6, 0, 0.3])); add(g, N(TORT, 0xffffff, [0, 0, 0], [0.29, 0.29, 0.29], [-0.5, 0, 1.3])); return g; }
    function paw(c) { var g = N(null); add(g, N(SPH, c, [0, -0.08, 0], [0.26, 0.2, 0.09])); [[-0.22, 0.14], [-0.08, 0.26], [0.08, 0.26], [0.22, 0.14]].forEach(function (q) { add(g, N(SPHL, c, [q[0], q[1], 0], [0.08, 0.1, 0.07])); }); return g; }
    function heart(c) { var g = N(null); add(g, N(SPHL, c, [-0.11, 0.05, 0], [0.15, 0.15, 0.12])); add(g, N(SPHL, c, [0.11, 0.05, 0], [0.15, 0.15, 0.12])); add(g, N(HEARTC, c, [0, -0.13, 0], [1.05, 1, 0.6], [Math.PI, 0, 0])); g.s = [1.4, 1.4, 1.4]; return g; }
    function fish(c) { var g = N(null); add(g, N(SPH, c, [0, 0, 0], [0.34, 0.18, 0.1])); add(g, N(CONE, c, [-0.4, 0, 0], [0.14, 0.2, 0.06], [0, 0, Math.PI / 2])); add(g, N(SPHL, 0x2b1d14, [0.2, 0.05, 0.08], [0.03, 0.03, 0.03])); return g; }
    var makers = [
      function () { return bone(0xfff1d6); }, function () { return ball(0xd7ef4f); }, function () { return yarn(0xff8fb1); },
      function () { return paw(0xffc83d); }, function () { return heart(0xff7aa2); }, function () { return fish(0x7cc8f0); },
      function () { return yarn(0xb79cff); }, function () { return paw(0x8fd4b0); }, function () { return ball(0xffb86b); }
    ];

    var objs = [], W = 1, H = 1, k = 0.01, docH = 1, mx = 0, my = 0, tmx = 0, tmy = 0;
    function rand(a, b) { return a + Math.random() * (b - a); }
    function build() {
      objs = [];
      var count = w.innerWidth < 700 ? 12 : 24;
      var span = docH * k + 6;
      for (var i = 0; i < count; i++) {
        var o = makers[i % makers.length]();
        var side = i % 2 ? 1 : -1, z = rand(-7, 1.5);
        var xr = w.innerWidth < 700 ? rand(1.2, 3.2) : rand(3.4, 7.5);
        o.base = [side * xr * (1 + (1.5 - z) * 0.06), 3 - (i + Math.random()) / count * span, z];
        o.sp = [rand(-0.5, 0.5), rand(-0.6, 0.6), rand(-0.4, 0.4)];
        o.ph = rand(0, 6.28);
        o.r = [rand(0, 6), rand(0, 6), rand(0, 6)];
        var sc = rand(0.8, 1.25) * (o.s ? o.s[0] : 1);
        o.s = [sc, sc, sc];
        objs.push(o);
      }
    }
    function resize() {
      var dpr = Math.min(w.devicePixelRatio || 1, 1.5);
      W = w.innerWidth; H = w.innerHeight;
      canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
      gl.viewport(0, 0, canvas.width, canvas.height);
      k = 7.2 / H;
      var nd = d.documentElement.scrollHeight;
      if (Math.abs(nd - docH) > 200 || !objs.length) { docH = nd; build(); }
    }
    if (fine) w.addEventListener('pointermove', function (e) { tmx = e.clientX / W * 2 - 1; tmy = e.clientY / H * 2 - 1; }, { passive: true });

    var drawList = [];
    function walk(n, parent) { n.W = parent ? mul(parent, local(n)) : local(n); if (n.mesh) drawList.push(n); for (var q = 0; q < n.kids.length; q++) walk(n.kids[q], n.W); }
    var bound = null;
    function drawNode(n) {
      if (bound !== n.mesh) {
        gl.bindBuffer(gl.ARRAY_BUFFER, n.mesh.vb);
        gl.enableVertexAttribArray(loc.aP); gl.vertexAttribPointer(loc.aP, 3, gl.FLOAT, false, 24, 0);
        gl.enableVertexAttribArray(loc.aN); gl.vertexAttribPointer(loc.aN, 3, gl.FLOAT, false, 24, 12);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, n.mesh.ib); bound = n.mesh;
      }
      gl.uniformMatrix4fv(loc.uM, false, n.W);
      gl.uniformMatrix3fv(loc.uNM, false, normalMat(n.W));
      gl.uniform3fv(loc.uC, n.color); gl.uniform1f(loc.uA, 1); gl.uniform1f(loc.uFlat, 0);
      gl.drawElements(gl.TRIANGLES, n.mesh.count, gl.UNSIGNED_SHORT, 0);
    }
    var t0 = performance.now(), last = 0;
    function frame(now) {
      var t = (now - t0) / 1000, dt = Math.min(0.05, Math.max(0, t - last)); last = t;
      mx += (tmx - mx) * Math.min(1, dt * 3); my += (tmy - my) * Math.min(1, dt * 3);
      var camY = -w.scrollY * k;
      var eye = [mx * 0.7, camY - my * 0.4, 12], tgt = [mx * 0.2, camY, 0];
      var VP = mul(persp(0.7, W / H, 0.1, 60), lookAt(eye, tgt, [0, 1, 0]));
      drawList = [];
      objs.forEach(function (o) {
        var vy = o.base[1] - camY;
        if (vy > 7 || vy < -7) return;
        if (!reduce) { o.r[0] += o.sp[0] * dt; o.r[1] += o.sp[1] * dt; o.r[2] += o.sp[2] * dt; }
        o.t = [o.base[0], o.base[1] + (reduce ? 0 : Math.sin(t * 0.8 + o.ph) * 0.25), o.base[2]];
        walk(o, null);
      });
      gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
      gl.enable(gl.DEPTH_TEST); gl.disable(gl.BLEND);
      gl.uniformMatrix4fv(loc.uVP, false, VP);
      gl.uniform3fv(loc.uL, norm([0.4, 0.9, 0.6])); gl.uniform3fv(loc.uE, eye);
      bound = null; drawList.forEach(drawNode);
    }
    var running = false;
    function loop(now) { if (!running) return; frame(now); requestAnimationFrame(loop); }
    function setRun(on) { if (reduce) on = false; if (on && !running) { running = true; requestAnimationFrame(loop); } else if (!on) running = false; }
    w.addEventListener('resize', function () { resize(); if (!running) frame(performance.now()); });
    if (reduce) w.addEventListener('scroll', function () { requestAnimationFrame(frame); }, { passive: true });
    d.addEventListener('visibilitychange', function () { setRun(!d.hidden); });
    w.addEventListener('load', function () { var nd = d.documentElement.scrollHeight; if (Math.abs(nd - docH) > 200) { docH = nd; build(); } });
    resize();
    frame(performance.now());
    canvas.classList.add('is-on');
    setRun(true);
})();
